export enum LeftSidebarTabs {
  DATABASES = "DATABASES",
  ENGINES = "ENGINES",
  SECURITY = "SECURITY",
}
